import styled from "styled-components";
/**
 * 隐藏滚动条
 * @author yangyongheng
 */
// tslint:disable-next-line:variable-name
export const StyleScrollBarHidden = styled.div `
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=index.js.map